import React from 'react';
import {
  AulaEditorWithoutTemplates as AulaEditorInner,
  AulaEditorProps as EditorPropsInner,
} from './EditorInner';
import { TemplatesDrawer } from './components/TemplatesDrawer/TemplatesDrawer';

type AulaEditorProps = Omit<EditorPropsInner, 'templatesDrawer'>;

/**
 * By wrapping AulaEditorInner with AulaEditor, the editor instance used inside
 * TemplatesDrawer via TemplatePreview component does not cause a dependency cycle.
 * @param props AulaEditorProps: the type that excludes templatesDrawer prop.
 * @returns AulaEditorInner: the original editor implementation inside this wrapper.
 */
const AulaEditor = (props: AulaEditorProps) => (
  <AulaEditorInner {...props} templatesDrawer={TemplatesDrawer} />
);

export { AulaEditorProps, AulaEditor };
